import { create } from "zustand";
import { createBuildingRegulationDetailsSlice, BuildingRegulationDetailsSlice } from "./buildingRegulationDetailsStore";
import { createEnforcementNoticeDetailsSlice, EnforcementNoticeDetailsSlice } from "./enforcementNoticeDetailsStore";
import { createPlanningApplicationDetailsSlice, PlanningApplicationDetailsSlice } from "./planningApplicationDetailsStore";
import { createCommentFilesSlice, CommentFilesSlice } from "./commentFilesStore";
import { createSearchTabsSlice, SearchTabsSlice } from "./searchTabsStore";
import { createBuildingRegulationsSearchSlice, BuildingRegulationsSearchSlice } from "./buildingRegulationsSearchStore";
import { createEnforcementAppealsSearchSlice, EnforcementAppealsSearchSlice } from "./enforcementAppealsSearchStore";
import { createEnforcementNoticesSearchSlice, EnforcementNoticesSearchSlice } from "./enforcementNoticesSearchStore";
import { createPlanningAppealsSearchSlice, PlanningAppealsSearchSlice } from "./planningAppealsSearchStore";
import { createPlanningApplicationsSearchSlice, PlanningApplicationsSearchSlice } from "./planningApplicationsSearchStore";
import { createPropertySearchSlice, PropertySearchSlice } from "./propertySearchStore";
import { createWeeklyListsSearchSlice, WeeklyListsSearchSlice } from "./weeklyListsSearchStore";
import { createUserCollectedDataTabsSlice, UserCollectedDataTabsSlice, UserDataTabNames } from "./userCollectedDataTabsStore";
export { UserDataTabNames };

export const useBuildingRegulationDetailsStore = create<BuildingRegulationDetailsSlice>()((...a) => ({
    ...createBuildingRegulationDetailsSlice(...a),
}));

export const useEnforcementNoticeDetailsStore = create<EnforcementNoticeDetailsSlice>()((...a) => ({
    ...createEnforcementNoticeDetailsSlice(...a),
}));

export const usePlanningApplicationDetailsStore = create<PlanningApplicationDetailsSlice>()((...a) => ({
    ...createPlanningApplicationDetailsSlice(...a),
}));

export const useCommentFilesStore = create<CommentFilesSlice>()((...a) => ({
    ...createCommentFilesSlice(...a),
}));

export const useSearchTabsStore = create<SearchTabsSlice>()((...a) => ({
    ...createSearchTabsSlice(...a),
}));

export const useBuildingRegulationsSearchStore = create<BuildingRegulationsSearchSlice>()((...a) => ({
    ...createBuildingRegulationsSearchSlice(...a),
}));

export const useEnforcementAppealsSearchStore = create<EnforcementAppealsSearchSlice>()((...a) => ({
    ...createEnforcementAppealsSearchSlice(...a),
}));

export const useEnforcementNoticesSearchStore = create<EnforcementNoticesSearchSlice>()((...a) => ({
    ...createEnforcementNoticesSearchSlice(...a),
}));

export const usePlanningAppealsSearchStore = create<PlanningAppealsSearchSlice>()((...a) => ({
    ...createPlanningAppealsSearchSlice(...a),
}));

export const usePlanningApplicationsSearchStore = create<PlanningApplicationsSearchSlice>()((...a) => ({
    ...createPlanningApplicationsSearchSlice(...a),
}));

export const usePropertySearchStore = create<PropertySearchSlice>()((...a) => ({
    ...createPropertySearchSlice(...a),
}));

export const useWeeklyListsSearchStore = create<WeeklyListsSearchSlice>()((...a) => ({
    ...createWeeklyListsSearchSlice(...a),
}));

export const useUserCollectedDataTabsStore = create<UserCollectedDataTabsSlice>()((...a) => ({
    ...createUserCollectedDataTabsSlice(...a),
}));
